import React, { useEffect, useState } from "react";

import { ConfigProvider } from 'antd';

import antLocale_ptPT from 'antd/lib/locale/pt_PT';
import antLocale_enGB from 'antd/lib/locale/en_GB';

import { IntlProvider, FormattedMessage, useIntl } from "react-intl";
import flatten from 'flat';

import lang_en_GB from './lang/en_GB.json';
import lang_pt_PT from './lang/pt_PT.json';

import Core from './common/Core';

import App from './App';

const lang = {
  en_GB: lang_en_GB,
  pt_PT: lang_pt_PT
};

function BaseLang(props) {
  const [languageCode, setLanguageCode] = useState(Core.currentLanguage());
  function onLanguageChange(value) {
    setLanguageCode(value);
  }
  return (
    <IntlProvider locale={Core.currentLanguage().toLowerCase().split('_').join('-')} messages={flatten(lang[Core.currentLanguage()])}>
      <ConfigProvider locale={Core.currentLanguage() == 'PT' ? antLocale_ptPT : antLocale_enGB}>
        <App onLanguageChange={onLanguageChange}/>
      </ConfigProvider>
    </IntlProvider>
  );
}

export default BaseLang;
